import { EventSourceHandler } from '@sellsy/sse';

export default class DocumentGeneratedEventSourceHandler extends EventSourceHandler {
    constructor() {
        super();
        this.type = 'corporation.document.generated';
    }

    handle(event) {
        window.EventBus.emit('document:generated', {
            publicLink: event.data.publicLink,
            id: event.data.id,
            fileid: event.data.fileid,
        });
    }
}
